// Marca do portal: só a logo da UEB (public/ueblogo.png), que já traz o nome.
// compact / logoOnly ajustam só o tamanho (ver .ueb-brand-mark no layout.css).

export default function Brand({ compact = false, onLight = false, logoOnly = false }) {
    return (
        <div className={`ueb-brand ${compact ? 'is-compact' : ''} ${onLight ? 'on-light' : ''} ${logoOnly ? 'is-logo-only' : ''}`}>
            <span className="ueb-brand-mark"><img src="/ueblogo.png" alt="UEB — Carteirinha de Estudante" /></span>
        </div>
    );
}
